import { router } from "@inertiajs/react";
import React from "react";
import { FiArrowRight } from "react-icons/fi";

import Typography from "@/components/Typography";
import { moneyFormatterWithoutCurrency } from "@/utils/moneyFormat";

interface DebtsSectionProps {
  total: number;
  count: number;
  consumersCount: number;
  isSPE?: boolean;
  showDetailsLink?: boolean;
}

const DebtsSection = ({
  total,
  count,
  consumersCount,
  isSPE = false,
  showDetailsLink = false,
}: DebtsSectionProps) => {
  return (
    <>
      <div>
        <Typography variant="h4" color={isSPE ? "black" : "white"}>
          Dívidas
        </Typography>
      </div>
      <div>
        <Typography variant="h6" color={isSPE ? "black" : "grey500"}>
          Valores referentes a todos os períodos
        </Typography>
      </div>
      <div className="grid grid-cols-1 divide-x divide-gray-600 md:grid-cols-3">
        <div className="flex flex-col py-10">
          <Typography variant="h5" color="black">
            Valor total das dívidas
          </Typography>

          <div className="flex flex-row gap-2">
            <Typography variant="h3" color="black">
              R$
            </Typography>
            <Typography variant="h3" color="white">
              {moneyFormatterWithoutCurrency(total)}
            </Typography>
          </div>
        </div>
        <div className="flex flex-col py-10 pl-5">
          <Typography variant="h5" color="black">
            Contas em dívida
          </Typography>

          <Typography variant="h3" color="white">
            {count}
          </Typography>
        </div>
        <div className="flex flex-col py-10 pl-5">
          <Typography variant="h5" color="black">
            Clientes em dívida
          </Typography>

          <Typography variant="h3" color="white">
            {consumersCount}
          </Typography>
        </div>
      </div>
      {showDetailsLink && (
        <div className="mt-4 flex items-center justify-between rounded-2xl bg-[#2f333b] px-7 py-6">
          <Typography variant="h6" color="white">
            Veja todos os inadimplentes da sua usina.
          </Typography>
          <div
            className="flex cursor-pointer items-center gap-2"
            onClick={() => router.get("/manager/debts")}
          >
            <Typography variant="link" color="white">
              Checar inadimplentes
            </Typography>
            <FiArrowRight color="white" />
          </div>
        </div>
      )}
    </>
  );
};

export default DebtsSection;
